import { InjectionToken } from '@angular/core';

export const ITEM_CRITICAL_CUSTOM_FIELD_KEY = new InjectionToken<string | null>(
    'ITEM_CRITICAL_CUSTOM_FIELD_KEY',
    { factory: () => null }
);

export const ITEM_HAZARD_CODE_CUSTOM_FIELD_KEY = new InjectionToken<
    string | null
>('ITEM_HAZARD_CODE_CUSTOM_FIELD_KEY', { factory: () => null });

export const ITEM_CATALOG_KIT_BOM_ENABLED = new InjectionToken<boolean>(
    'ITEM_CATALOG_KIT_BOM_ENABLED',
    { factory: () => false }
);
